module.exports = __webpack_public_path__ + "img/dsm.5481f334.png";